<template>
  <a-spin :spinning="loading_cancel" tip="Loading...">
    <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
      <div v-if="id === null || id === undefined">
        <a-card class="m-wrong">
          <m-anim
            :options="notfound"
            class="anim"
            :height="getScreen ? 200 : 500"
            :width="getScreen ? 200 : 500"
          ></m-anim>
          <h3>>Not Found</h3>
          <p>
            Return to the previous page and make the selection manifest again!
          </p>
          <a-button type="primary" block>
            <router-link to="/piutangKaryawan">
              <a-icon type="rollback" />&nbsp; Return
            </router-link>
          </a-button>
        </a-card>
      </div>
      <div v-else>
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-card :loading="loading" class="margin-bottom">
              <div slot="title">
                <div>
                Manifest Receivables Employee
                <Status v-if="data.header.close_dt!=null" :status="'Closed'" />
                </div>
                <small class="m-display-block m-text-small">{{
                  data.header.piutang_karyawan_no
                }}</small>
              </div>

              <a-popover slot="extra" trigger="focus" placement="bottom">
                <span slot="title">Select Action</span>
                <ul class="m-list-wrapper bordered" slot="content">
                  <li
                    v-if="getAuth.username == data.header.tlc_create"
                  >
                    <a-button-group>
                      <a-button
                        :disabled="!button_edit"
                        @click="handleEdit"
                        type="dashed"
                        icon="edit"
                        >Edit</a-button
                      >
                      <a-button
                        :disabled="!btn_cancel"
                        @click="handlecanceltrans"
                        type="danger"
                        icon="close-square"
                        :loading="loading_cancel"
                        >Cancel</a-button
                      >
                      <a-button
                        :disabled="!btn_close"
                        @click="()=>{visibleCloseDialog = true}"
                        type="danger"
                        icon="close-square"
                        >Close</a-button
                      >
                    </a-button-group>
                  </li>
                </ul>
                <a-button icon="more" :size="getScreen ? 'small' : 'default'">{{
                  getScreen ? "" : "Action"
                }}</a-button>
              </a-popover>

              <div class="m-card-body">
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title" for>Create Date</span>
                    <span class="m-list-desc"
                      >{{
                        data.header.create_dt
                          ? moment(
                              data.header.create_dt,
                              getStandartFormatDate
                            ).format(getDefaultDateFormat)
                          : "-"
                      }}
                    </span>
                  </li>
                  
                  <li>
                    <span class="m-list-title" for>End User</span>
                    <span class="m-list-desc">{{data.header.end_user}}</span>
                  </li>
                   <li>
                    <span class="m-list-title" for>Installment Amount</span>
                    <span class="m-list-desc">{{ data.header.installment_amount + "x Installment " }}</span>
                  </li>
                   <li>
                    <span class="m-list-title" for>Installment Value</span>
                    <span class="m-list-desc">{{ formatCurrency(currency,data.header.installment_value) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Value</span>
                    <span class="m-list-desc">{{ formatCurrency(currency,data.header.value) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Down Payment</span>
                    <span class="m-list-desc">{{ formatCurrency(currency,data.header.dp) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Remaining Balance</span>
                    <span class="m-list-desc">{{ formatCurrency(currency,data.header.remaining_balance) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Description</span>
                    <span class="m-list-desc">{{ data.header.description }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Note</span>
                    <span class="m-list-desc">{{data.header.note}}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>File Attachment</span>
                    <span class="m-list-desc margin-top">
                      <a-button
                        v-if="data.header.file_attachment"
                        class="margin-top ant-menu-submenu ant-menu-submenu-selected"
                        icon="download"
                        size="default"
                        @click="handlePreview(data.header.file_attachment)"
                      >View Document</a-button>
                      
                    </span>
                  </li>
                </ul>
              </div>
            </a-card>

            <a-collapse v-if="getScreen" class="margin-top" activeKey="1">
              <a-collapse-panel key="1" :forceRender="true">
                  <div slot="header" class="m-display-flex space-between align-middle margin-right">
                    <h4 class="margin-remove">Detail Installment Payment</h4>
                    <a-button
                      @click="handleActionmodal()"
                      
                      icon="plus"
                      size="small"
                      type="primary"
                      >Installment Payment</a-button>
                  </div>
                <a-list
                  itemLayout="vertical"
                  :dataSource="data.detail_invoice"
                  :pagination="pagination"
                >
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <span slot="title">{{
                        item.deskripsi ? item.deskripsi : "Terima Uang Muka"
                      }}</span>
                      <div slot="description" class="margin-remove">
                        <span>{{
                          moment(item.tanggal).format(getDefaultDateFormat)
                        }}</span>
                        <div>
                          <span>{{ item.label }}</span>
                          <h4 class="margin-remove">
                            {{ formatRupiah(item.nilai) }}
                          </h4>
                        </div>
                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse>
            <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
              <a-collapse-panel key="1" :disabled="true">
                <div slot="header" class="m-display-flex space-between align-middle">
                  <h4 class="margin-remove">Detail Installment Payment</h4>
                  <a-button
                    v-if="btn_add_payment"
                    @click="handleActionmodal()"
                    style="margin-right:8px"
                    icon="plus"
                    size="small"
                    type="primary"
                    >Installment Payment</a-button>
                </div>
                <a-input-search
                  v-model="search"
                  placeholder="Quick Search"
                  allowClear
                  :change="searching"
                  class="margin-bottom"
                />
                <a-table
                  :rowKey="(record, index) => {
                      return index;}
                  "
                  :columns="columns"
                  :dataSource="tableData"
                  :pagination="pagination"
                  size="small"
                  bordered
                  :scroll="{ x: 700 }"
                >
                  <template slot="scopecreate_dt" slot-scope="item">
                    <span>{{ moment(item, getDefaultDateFormat).format(
                      'DD-MM-YYYY'
                    ) }}</span>
                  </template>scopedocument
                  <template slot="scopeno_bkm" slot-scope="item">
                    <span v-if="item.no_trans">
                      <a @click="handlerefBKM(item.id_transaksi)">{{ item.no_trans }}</a>
                    </span>
                    <span v-else>
                      -
                    </span>
                  </template>
                  <span slot="scopevalue" slot-scope="item">
                    <CurrencyJustified
                      v-if="item.value"
                      :currencyValue="currency"
                      :valueNumber="item.value"
                    />
                    <div v-else style="text-align: center; width: 100%">-</div>
                  </span>
                  <template slot="scopedocument" slot-scope="item">
                    <a v-if="item.document" @click="handleViewDoc(item.document)">View Document</a>
                    <span v-else>
                      -
                    </span>
                  </template>
                  <div slot="footer" class="padding-all">
                    <a-row type="flex">
                      <a-col :span="10" :order="1" class="m-text-align left m-text-bold"
                        >Total Installment Payment</a-col
                      >
                      <a-col
                        :span="9"
                        :order="2"
                        class="m-text-align left m-text-bold"
                      >
                        <CurrencyJustified
                          :currencyValue="currency"
                          :valueNumber="total_installment"
                        />
                      </a-col>
                      <a-col
                        :span="3"
                        :order="3"
                        class="m-text-align left m-text-bold"
                      ></a-col>
                    </a-row>
                    <!-- <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left"
                        >Total Credit</a-col
                      >
                      <a-col
                        :span="7"
                        :order="2"
                        class="m-text-align left m-text-bold"
                      >
                        <CurrencyJustified
                          :currencyValue="currtotalSaldo"
                          :valueNumber="Number(data.header.total_klaim_kas)"
                        />
                      </a-col>
                      <a-col
                        :span="3"
                        :order="3"
                        class="m-text-align left m-text-bold"
                      ></a-col>
                    </a-row>
                    <a-divider v-if="!isShowColDebit"></a-divider>
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left"
                        >Remaining Balance</a-col
                      >
                      <a-col
                        :span="7"
                        :order="2"
                        class="m-text-align left m-text-bold"
                      >
                        <CurrencyJustified
                          :currencyValue="currtotalSaldo"
                          :valueNumber="totalSaldo"
                        />
                      </a-col>
                      <a-col
                        :span="3"
                        :order="3"
                        class="m-text-align left m-text-bold"
                      ></a-col>
                    </a-row> -->
                  </div>
                </a-table>
              </a-collapse-panel>
            </a-collapse>

            <a-card
              class="margin-top"
              :loading="loading"
              v-if="jenis === 'Approve'"
            >
              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Actions">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                      item.aksi
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    :loading="loadingSave"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-card>
            <!-- <a-card
              class="margin-top"
              v-if="data.jenis === 'Transfer' && status_transfer"
            >
              <div slot="title">
                Manifest Actions &nbsp;<i
                  v-if="data.jenis == 'Transfer' && !status_transfer"
                  style="color: red !important"
                  >(Funding has not been set)</i
                >
              </div>
              <div class="m-text-align right margin-remove" slot="extra">
                <h5 class="m-text-align right margin-remove">
                  remaining balance
                </h5>
                <a-tag color="green" class="m-text-align right margin-remove">{{
                  formatCurrency(data.currency, sisa_tf)
                }}</a-tag>
              </div>
              <template v-if="!(data.jenis == 'Transfer' && !status_transfer)">
                <a-form :form="formTransfer">
                  <a-row :gutter="16">
                    <a-form-item label="Status">
                      <a-select
                        @change="onChangeStatus"
                        v-decorator="[
                          'aksi',
                          {
                            rules: [{ required: true }],
                            initialValue: data.aksi[0].aksi,
                          },
                        ]"
                      >
                        <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                          da.aksi
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Transfer Date">
                      <a-date-picker
                        placeholder="Select Date"
                        :format="dateFormat"
                        v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                      />
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                      <a-upload
                        :fileList="fileList"
                        :showUploadList="true"
                        :disabled="fileList.length > 0"
                        v-decorator="[
                          'file_transfer',
                          { rules: [{ required: reqFileTf }] },
                        ]"
                        accept=".jpg, .png, .pdf"
                        :remove="handleRemove"
                        :beforeUpload="beforeUpload"
                      >
                        <a-button> <a-icon type="upload" />Select File </a-button>
                      </a-upload>
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Transfer Value">
                      <a-checkbox
                        :defaultChecked="true"
                        @change="onchangeNilaiTf"
                        :checked="checkTransferValue"
                        >Transfer value according to remaining balance</a-checkbox
                      >
                      <a-input-number
                        :min="0.1"
                        :max="sisa_tf"
                        class="m-display-block" style="width:150px"
                        v-decorator="[
                          'value_transferan',
                          {
                            rules: [{ required: true }],
                            initialValue: temp_sisa_tf,
                          },
                        ]"
                        :disabled="disableNilaiTf"
                        @keydown="onlyNumber"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-item>

                    <a-form-item label="Note">
                      <a-textarea
                        placeholder="Write the note here ... "
                        :rows="4"
                        v-decorator="[
                          'catatan',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>
                  </a-row>
                  <a-form-item :wrapper-col="{ span: 24 }">
                    <a-button
                      @click="handleActionConfirm"
                      block
                      type="primary"
                      html-type="submit"
                      >Save</a-button
                    >
                  </a-form-item>
                </a-form>
              </template>
            </a-card> -->
          </a-col>

          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <!-- <a-card :loading="loading" 
            v-if="data.header.type.toLowerCase()=='company'"
            :class="getScreen ? 'margin-top' : ''">
              <div slot="title">Evidence of Transfer</div>
              <div>
                <a-alert
                  v-if="data.bukti_transfer.length <= 0"
                  type="error"
                  message="No evidence of transfer was uploaded"
                  banner
                />
                <a-list
                  itemLayout="horizontal"
                  :dataSource="data.bukti_transfer"
                  v-else
                >
                  <Empty
                    v-if="
                      data.bukti_transfer
                        ? data.bukti_transfer.length <= 0
                        : data.bukti_transfer
                    "
                  />
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div slot="title" class="m-display-flex space-between">
                        <h3 class="margin-remove">
                          {{ moment(item.tgl_tf).format(getDefaultDateFormat) }}
                        </h3>

                        <a-button
                          @click="handleViewDt(item)"
                          size="small"
                          type="default"
                          icon="eye"
                          >View</a-button
                        >
                        <h4 class="margin-remove">
                          {{ formatCurrency(data.mata_uang, item.value_tf) }}
                        </h4>
                      </div>
                      <img
                        class="m-image-icon"
                        slot="avatar"
                        :src="$serviceUrl + item.url"
                      />\
                      <p slot="description" class="margin-remove">
                        {{ item.user_tf }}
                      </p>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </div>
            </a-card>-->

            <a-collapse activeKey="1" :class="getScreen ? 'margin-top': ''">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <Status :status="data.header.close_sts=='Closed' ? 'Closed': data.last_status" />
                    <a-button
                      @click="historyToggle"
                      type="default"
                      size="small"
                      class="margin-right-small"
                    >
                      <a-icon type="undo" />
                    </a-button>
                  </div>
                </div>
                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ data.header.tlc_create }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">
                        {{
                          moment(data.header.date_guarantee).format(
                            getDefaultDateFormat
                          )
                        }}
                      </h4>
                      <span class="m-text-small" v-if="data.header.note">{{
                        data.header.note
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">Created</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    v-for="workflow in data.status"
                    :key="workflow.step_no"
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor }} - {{ workflow.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                        {{
                          moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                        }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>

            <a-card 
              v-if="data.header.close_sts=='Closed'"
              class="margin-top">
              <div slot="title">Closing Information</div>
              <a-alert
                type="warning"
              >
                <template slot="message">
                  <span><b>Close date : </b>{{ data.header.close_dt }}</span><br/>
                  <span><b>Close by : </b>{{ data.header.tlc_close }}</span><br/>
                  <span><b>Description : </b>{{ data.header.note_close }}</span>
                </template>
              </a-alert>
            </a-card>

            <!--<a-collapse
              :class="data.header.type.toLowerCase()=='company' ? 'margin-top' : ''"
              activeKey="1"
            >
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Related Document</h4>
                </div>
                <a-list
                  itemLayout="horizontal"
                  :dataSource="data.related_document"
                >
                  <Empty
                    v-if="
                      data.related_document
                        ? data.related_document.length <= 0
                        : data.related_document
                    "
                  />
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div
                        slot="title"
                        class="m-display-flex space-between align-middle"
                      >
                        <a
                          @click="
                            handleView({
                              ...item,
                              id_manifest: item.id_manifest,
                            })
                          "
                          >{{ item.no_trans }}</a
                        >
                      </div>
                      <template slot="description">
                        <div>{{ item.description }}</div>
                        <div>{{ formatCurrency("", item.value_bkk) }}</div>
                        <div>{{ item.tgl }}</div>
                      </template>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse> -->

          </a-col> 
        </a-row>
      </div>

      <a-modal
        v-if="modalVisible==true"
        v-model="modalVisible"
        title="Installment Payment"
        :width="500"
        centered
        :maskClosable="false"
        @ok="handleOk"
        @cancel="handleClose"
      >

        <a-form-model ref="reconform" :model="formmodal" :rules="rules">
          <div style="text-align:right"><b>
            Installment No : {{seq_installment_no}}
          </b></div>
          <a-divider class="margin-small" />
          <a-form-model-item
            ref="valu"
            label="Value (IDR)"
            prop="valu"
          >
            <a-input-number
              :min="0"
              class="m-width-full m-text-align right"
              @keydown="onlyNumber"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              v-model="formmodal.valu"
            ></a-input-number>
          </a-form-model-item>
          <a-form-model-item ref="file" prop="file" label="Upload Document File">
            <a-upload
                v-model="formmodal.file"
                :showUploadList="true"
                :fileList="push"
                :beforeUpload="beforeUpload"
                :remove="handleRemoveList"
              >
                <a-button
                  ref="btndocument"
                  icon="upload"
                  >Select File
                </a-button>
              </a-upload>
          </a-form-model-item>
        </a-form-model>
        <template slot="footer">
          <a-button key="back" @click="handleClose"> Cancel </a-button>
          <a-button key="submit" :loading="loading" type="primary" @click="handleOk">
            Save
          </a-button>
        </template>
      </a-modal>

      <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
        <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

        <ul class="m-list-wrapper bordered">
          <li v-for="history in data.history" :key="history.id_notifikasi">
            <div v-if="history.aksi === '1' || history.aksi === '3'">
              <div class="m-display-flex space-between">
                <h3 class="margin-remove m-list-title">
                  {{ history.as_from }} | {{ history.tlc_from }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
            <div v-else-if="history.aksi === '2' || history.aksi === '4'">
              <div class="m-display-flex space-between">
                <h3
                  class="margin-remove m-list-title"
                  v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
                >
                  {{ history.as_from }} | {{ history.tlc_from }}
                </h3>
                <h3 class="margin-remove m-list-title" v-else>
                  {{ history.as_to }} | {{ history.tlc_to }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
          </li>
        </ul>
      </a-modal>

      <a-modal v-model="visibleCloseDialog" @ok="historyToggle" @cancel="handleTransClose">
        <span slot="title">Close Receivable Employee</span>

        <b>Remaining Balance : {{ formatCurrency("IDR", data.header.remaining_balance) }}</b>
        <a-form-item label="Description" required>
          <a-textarea
            placeholder="Write the description here ... "
            :rows="4"
            v-model="catatanClose"
          />
        </a-form-item>
        <template slot="footer">
          <!-- <a-button key="back" @click="handleClose"> Cancel </a-button> -->
          <a-button key="submit" :loading="loading_close" type="primary" @click="handleclosetrans">
            Save
          </a-button>
        </template>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "piutangKaryawanManifest",
  components: {
    ACol,
    Status,
    "m-anim": lottie,
    Status,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (this.push == null ||this.push.length==0) {
        callback(new Error("Please input File Attachment"));
      } else {
        callback();
      }
    };
    let maxInstalment_validation = (rule, value, callback) => {
      if (!this.formmodal.valu){
        callback(new Error("Please input File Attachment"));
      } else if (value>this.sisa_installment) {
        callback(new Error("Max value is "+this.formatCurrency(this.currency,this.sisa_installment)));
      } else {
        callback();
      }
    };
    return {
      notfound: { animationData: notfound, loop: true },
      loading: false,
      loading_cancel: false,
      loading_close: false,
      loadingSave: false,
      data: {
        bukti_transfer: [],
        status: [],
        header: [{
          type: "",
          tlc_create: '',
          create_dt: moment(),
          use_for: "",
          value: 0,
          description: "",
          installment_amount: "",
          note: "",
          end_user: "",
        }],
        jenis:null,
        timeline:[],
        history:[]
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      pagination: {
        onChange: (page) => {},
        pageSize: 10,
        size: "small",
      },
      total_installment: 0,
      currency: 'IDR',
      btn_add_payment: false,
      dateFormat: "DD-MM-YYYY",
      status_transfer: null,
      sisa_tf: 0,
      reqFileTf: true,
      fileList: [],
      checkTransferValue: true,
      temp_sisa_tf: "",
      disableNilaiTf: true,
      modalVisible: false,
      previewImage: "",
      formmodal: {
        valu: undefined,
        file:[]
      },
      rules:{
        valu: [
          {
            required: true,
            validator:maxInstalment_validation,
            trigger: "blur",
          },
        ],
        file: [{
            required: true,
            validator: doc_validation,
            trigger: "change",
        },],
      },
      push:[],
      seq_installment_no:0,
      sisa_installment:0,
      btn_cancel:false,
      btn_close: false,
      button_edit: false,
      jenis: '',
      visibleHistory: false,
      visibleCloseDialog: false,
      catatanClose: ""
    };
  },
  beforeCreate() {
    this.formTransfer = this.$form.createForm(this);
    this.form = this.$form.createForm(this);
    this.formmodal = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getDateTimeFormat",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const kolom = [
            {
              title: "Date",
              dataIndex: "create_dt",
              width: 100,
              scopedSlots: { customRender: "scopecreate_dt" },
              key: "date",
              sorter: (a, b) =>
                new Date(
                  moment(a.create_dt, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ) -
                new Date(
                  moment(b.create_dt, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ),
              fixed: "left",
              align: "center"
            },
            {
              title: "Installment",
              dataIndex: "installment_no",
              key: "installment_no",
              align: "right",
              width: 120,
              sorter: (a, b) => a.installment_no.localeCompare(b.installment_no),
            },
            {
              title: "Value",
              key: "value",
              width: 150,
              sorter: (a, b) => a.value - b.value,
              scopedSlots: { customRender: "scopevalue" },
            },
            {
              title: "Payment Number",
              key: "bkm",
              width: 200,
              sorter: (a, b) => a.no_bkm.localeCompare(b.no_bkm),
              scopedSlots: { customRender: "scopeno_bkm" },
            },
            {
              title: "Document",
              key: "document",
              width: 150,
              align: "center",
              sorter: (a, b) => a.document.localeCompare(b.document),
              scopedSlots: { customRender: "scopedocument" },
            },
          ];
      return kolom;
    },
    searching() {
      if (this.search) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.tableData = this.tableDataTemp.filter(
          (obj) =>
            (this.formatCurrency(this.currency,obj.value)).toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            obj.installment_no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.bkm_no ? obj.bkm_no : "").toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            moment(obj.create_dt, "DD-MM-YYYY")
              .format("DD-MM-YYYY")
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
  },
  methods: {
    moment,
    fetchManifest() {
      this.$store
      .dispatch("getManifestPiutangKaryawan", { auth: this.getAuth, id_manifest: this.id})
      .then((response) => {
        try {
          this.data = {
          header: response.header[0],
          related_document: response.dokumen_terkait,
          last_status: response.last_status,
          status: response.status_app,
          bukti_transfer: response.buktiTransfer,
          jenis: response.jenis,
          aksi: response.aksi,
          history: response.notifikasi,
          };
          this.tableData = response.dtl_installment;
          this.tableDataTemp = response.dtl_installment;
          this.status_transfer = response.status_transfer;
          this.sisa_tf = response.sisa_tf;
          this.temp_sisa_tf = this.sisa_tf;
          this.total_installment = response.total_installment;
          this.currency = response.currency;
          this.btn_add_payment = response.btn_add_payment;
          this.seq_installment_no = response.seq_installment_no;
          this.sisa_installment = response.sisa_installment;
          this.button_edit = response.btn_edit;
          this.btn_cancel = response.btn_cancel;
          this.btn_close = response.btn_close;
          this.btn_add_payment = response.btn_add_payment;
          this.jenis = response.jenis;

          this.loading = false;
        } catch (err) {
          this.loading = false;
          this.displayMessageValue("error", err);
          this.$router.go(-1);
        }
      })
      .catch((err) => {
        if (!err.response) {
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.loading = false;
            this.$router.push({ name: "beranda" });
          }
      });
    },
    handlePreview(url) {
        window.open(this.$serviceUrl+url, "_blank");
    },
    onChangeStatus(val) {
      if (val === "Transferred") {
        this.reqFileTf = true;
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.push.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.push.indexOf(file);
        const newFileList = this.push.slice();
        newFileList.splice(index, 1);
        this.push = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.formTransfer.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      if (this.data.jenis === "Transfer") {
        this.handleActionTransfer();
      } else {
        this.handleActionAprove();
      }
    },
    handleActionAprove() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan ? values.catatan : "");

        this.loadingSave = true;
        Axios({
          method: "post",
          url: this.$serviceUrl + "piutang_karyawan/approval",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.loadingSave = false;
            this.displayMessage("success");
            this.$router.go(0);
          })
          .catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      });
    },
    handleActionTransfer() {
      this.formTransfer.validateFields((err, values) => {
        if (err) {
          return;
        }
        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan);

        if (this.checkTransferValue) {
          formData.append("cek_value", 1);
          formData.append("value_transfer", 0);
        } else {
          formData.append("cek_value", 0);
          formData.append("value_transfer", values.value_transferan);
        }
        formData.append(
          "tgl_transfer",
          moment(values.tgl_tf).format(this.getStandartFormatDate)
        );
        formData.append("file_transfer", values.file_transfer.file);

        this.loadingSave = true;
        Axios({
          method: "post",
          url: this.$serviceUrl + "piutang_karyawan____/approval",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.loadingSave = false;
            this.displayMessage("success");
            this.$router.go(0);
          })
          .catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      });
    },
    handleViewDt(file) {
      let tipe = file.url.substr(file.url.length - 3);
      if (tipe == "jpg" || tipe == "jpeg" || tipe == "png") {
        this.previewImage = this.$serviceUrl + file.url;
        this.modalVisible = true;
      } else {
        window.open(this.$serviceUrl + file.url, "_blank");
      }
    },
    handleActionmodal(){
      this.modalVisible = true;
      this.formmodal.valu = null;
      this.formmodal.file = null;
      this.push = [];
    },
    handleClose(){
      this.$refs.reconform.resetFields();
      this.push = [];
      this.modalVisible = false;
    },
    handleOk(){
      this.loading = true;

      this.$refs.reconform.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          this.loading = false;
          return;
        }
      
        let formData = new FormData();
        formData.append("tlc",this.getAuth.username);
        formData.append("id_manifest", this.id);
        formData.append("value", this.formmodal.valu);
        formData.append("installment_no", this.seq_installment_no);
        formData.append("upload_file", this.push[0]);
      
        this.$store.dispatch("submitpayPiutangKaryawan", { auth: this.getAuth, 
        payload: formData })
        .then((res) => {
          console.log(res)
          if(res.status==true){
            this.modalVisible = false;
            this.displayMessageValue("success-other", res.message);
            //this.$router.go(0);
            this.fetchManifest();
          }else{
            if (res.message) {
              this.displayMessageValue(
                "error-other",
                res.message
              );
            }else{
              let responses = Object.assign({}, res);
              this.displayMessageValue("error", responses);
            }
          }
          this.loading = false;

        })
        .catch(err => {
          console.log("err",err);
          this.loading = false;
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
      });
    },
    handleRemoveList() {
      this.formmodal.file = undefined;
      this.push = [];
    },
    handleViewDoc(url) {
      window.open(this.$serviceUrl + url);
    },
    handlerefBKM(id_manifest){
      this.$router.push({
            name: "pembayaranpiutang-manifest-hrd",
            params: { id: id_manifest },
          });
    },
    handleEdit() {
      this.$router.push({
        name: "piutangkaryawan-edit-keu",
        params: { id: this.id },
      });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    handleclosetrans(){
      if(this.catatanClose==""){
        this.displayMessageValue("error-other", "Description Can't be empty!");
      }else{
        this.confirmMessageValue("confirm-close", null, null);
      }
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    canceltrans() {
      this.loading_cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "piutang_karyawan",
        id_manifest: this.id,
        code_trans: this.data.header.piutang_karyawan_no,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.loading_cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.loading_cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    closetrans() {
      const data = {
        piutang_karyawan_id: this.id,
        remaining_balance: this.data.header.remaining_balance,
        description: this.catatanClose
      };
      this.loading_close = true;
      Axios({
          method: "post",
          url: this.$serviceUrl + "piutang_karyawan/close",
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then((response) => {
          this.loading_cancel = false;
          this.displayMessageValue("successClose", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.loading_close = false;
          this.displayMessageValue("error-other", error.message);
        });
    },
    handleTransClose(){
      this.catatanClose = ""
      this.visibleCloseDialog = false
    }
  },
  
  mounted() {
    this.fetchManifest();
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("handleClose", this.closetrans);
    
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("handleClose", this.closetrans);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.formmodal = this.$form.createForm(this);
        this.formTransfer = this.$form.createForm(this);
        this.reqFileTf = true;
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
      }
    },
  },
};
</script>

<style></style>
